import { useQuery, UseQueryOptions } from 'react-query';

import { Guid, DataRoomDocument } from '../../models';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';

export function useShowDeletedDocumentsQuery(
	guid: Guid | undefined,
	options?: Omit<UseQueryOptions<DataRoomDocument[], unknown, DataRoomDocument[]>, 'queryKey' | 'queryFn'> | undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.Documents.Deleted(guid),
		() => AxiosUtils.getResponseData<DataRoomDocument[]>(api.get(CerebroApiEndpoints.Documents.Deleted(guid))),
		options
	);
}
